@if (ready()) {
  @if (items().length > 0) {
    <cdk-virtual-scroll-viewport
      class="virtual-scroll-viewport"
      [itemSize]="rowSize()"
      [style.height]="viewportHeightStyle()"
    >
      <div
        class="virtual-scroll-row"
        *cdkVirtualFor="let row of rows(); trackBy: trackRow"
      >
        @for (item of row; track trackItem($index, item)) {
          <div class="virtual-scroll-item">
            <ng-container
              [ngTemplateOutlet]="itemTemplate"
              [ngTemplateOutletContext]="{ $implicit: item }"
            />
          </div>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  } 
  @else if (emptyMessage()) {
    <div class="virtual-scroll-empty" [style.height]="emptyHeightStyle()">
      <p>{{ emptyMessage() }}</p>
    </div>
  }
} @else {
  <div class="virtual-scroll-viewport" [style.height]="viewportHeightStyle()"></div>
}